import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ConfirmDialogData} from "../confirm-dialog/confirm-dialog.component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validEmailAddress} from "../../validator/email-validator";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SettlementTemplate} from "../../interface/settlement-template";
import {SettlementTemplateService} from "../../services/settlement-template.service";
import {HttpErrorResponse} from "@angular/common/http";

export interface SendMailDialogData {
  text: string;
  settlementTemplate: SettlementTemplate;
}
@Component({
  selector: 'app-send-mail-dialog',
  templateUrl: './send-mail-dialog.component.html',
  styleUrls: ['./send-mail-dialog.component.scss']
})
export class SendMailDialogComponent implements OnInit {
  text = '';
  mailForm: FormGroup;
  emailControl: FormControl;
  settlementTemplateObject: SettlementTemplate;
  processingRequest = false;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<SendMailDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: SendMailDialogData,
    private snack: MatSnackBar,
    private settlementTemplateService: SettlementTemplateService
  ) {
    this.text = data.text;
    this.settlementTemplateObject = data.settlementTemplate;
    this.mailForm = fb.group({
      email: this.emailControl = fb.control('', [Validators.required, validEmailAddress()]),
      totalCommission: fb.control('', [Validators.required]),
      toPayNet: fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  confirm(): void {
    if (!this.mailForm.valid) {
        this.mailForm.markAllAsTouched();
        this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
          duration: 2000,
        });
        return;
    }
    this.processingRequest = true;
    this.settlementTemplateService.sendMail(
      this.settlementTemplateObject.uuid,
      this.mailForm.get('email').value,
      this.settlementTemplateObject.billingMonth,
      this.mailForm.get('totalCommission').value,
      this.mailForm.get('toPayNet').value
    )
      .subscribe({
        next: () => {
          this.snack.open('Pomyślnie wysłano email', '', {duration: 2000});
          this.dialogRef.close(true);
        },
        error: (response: HttpErrorResponse) => {
          this.processingRequest = false;
          this.snack.open(response.error.text, response.status.toString(), {duration: 5000});
        }
      });

  }

  decline(): void {
    this.dialogRef.close(false);
  }

  selectedUser(user): void{
    if (user) {
      this.emailControl.setValue(user.email);
    }
  }
}
